module.exports = __webpack_public_path__ + "img/login_cover.d1763b4d.svg";